<template>
    <svg
        viewBox="0 0 468 353"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width="468"
        height="353"
        class="h-auto">
        <g filter="url(#filter0_i_2149_8119)">
            <path
                d="M458.493 229.095C464.113 227.527 468 222.408 468 216.573L468 136.427C468 130.592 464.113 125.473 458.493 123.905L16.4932 0.601065C8.20648 -1.71067 3.08148e-05 4.5198 3.00627e-05 13.1229L1.49694e-06 339.877C7.44824e-07 348.48 8.20645 354.711 16.4932 352.399L458.493 229.095Z"
                fill="url(#paint0_linear_2149_8119)" />
        </g>
        <defs>
            <filter
                id="filter0_i_2149_8119"
                x="0"
                y="0.115234"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
                width="468"
                height="352.77">
                <feFlood
                    flood-opacity="0"
                    result="BackgroundImageFix" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha" />
                <feOffset />
                <feGaussianBlur stdDeviation="70.4" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.454902 0 0 0 0 0.247059 0 0 0 0 0.854902 0 0 0 1 0" />
                <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_2149_8119" />
            </filter>
            <linearGradient
                id="paint0_linear_2149_8119"
                x1="234"
                y1="357"
                x2="234"
                y2="-3.99999"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#743FDA" />
                <stop
                    offset="1"
                    stop-color="#743FDA"
                    stop-opacity="0" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script setup lang="ts"></script>
